module.exports = __webpack_public_path__ + "static/media/hubworld-pulse.2a631d9d.gif";